import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  POST_PAYMENTS_PREFERENCES_URL,
  POST_PARENTING_SCHEDULE_PREFERENCES_URL,
  GET_PREFERENCES_URL
} from '@/constants/ApiConstants'

const state = {}

const getters = {}

const actions = {
  [action.POST_PAYMENTS_PREFERENCES](_, data) {
    return ApiService.post(POST_PAYMENTS_PREFERENCES_URL, data);
  },
  [action.POST_PARENTING_SCHEDULE_PREFERENCES](_, data) {
    return ApiService.post(POST_PARENTING_SCHEDULE_PREFERENCES_URL, data);
  },
  [action.GET_PREFERENCES]() {
    return ApiService.get(GET_PREFERENCES_URL);
  },
}

export default {
  state,
  actions,
  getters
}
